/**
 * Header hover effect
 */
export const headerHover = () => {
	const eventHandlers = new Map();

	let handlerId = 0;
	const getUniqueId = () => `hover_header_${handlerId++}`;

	function hoverHeader() {
		const topMenu = document.querySelector(
			'.desktop-nav .primary-navigation'
		);
		if (!topMenu) return;

		const menuItems = topMenu.querySelectorAll('.menu-item');

		// Helper — closes only top-level menu items (not nested sub-items)
		const closeTopLevel = () => {
			menuItems.forEach((navItem) => {
				// A top-level item has no ancestor with the class .sub-menu
				if (!navItem.closest('.sub-menu')) {
					navItem.classList.remove('is-opened');
					navItem.setAttribute('aria-expanded', 'false');
					navItem
						.querySelector('.sub-menu')
						?.setAttribute('aria-expanded', 'false');
				}
			});
		};

		menuItems.forEach((item) => {
			const subMenu = item.querySelector('.sub-menu');

			const handlers = {
				mouseenter: () => {
					document.body.classList.add('menu-item__hover');
					// Ensure only this (top-level) item is open
					if (!item.closest('.sub-menu')) {
						closeTopLevel();
					}
					item.classList.add('is-opened');
					item.setAttribute('aria-expanded', 'true');
					subMenu?.setAttribute('aria-expanded', 'true');
				},
				mouseleave: (e) => {
					if (!item.contains(e.relatedTarget)) {
						item.classList.remove('is-opened');
						item.setAttribute('aria-expanded', 'false');
						subMenu?.setAttribute('aria-expanded', 'false');

						// Remove global hover class ONLY if we've left the whole nav
						if (!topMenu.contains(e.relatedTarget)) {
							document.body.classList.remove('menu-item__hover');
						}
					}
				},
				focus: () => {
					document.body.classList.add('menu-item__hover');
					// Close any other open top-level menus first
					if (!item.closest('.sub-menu')) {
						closeTopLevel();
					}
					item.classList.add('is-opened');
					item.setAttribute('aria-expanded', 'true');
					subMenu?.setAttribute('aria-expanded', 'true');
				},
				blur: (e) => {
					if (!item.contains(e.relatedTarget)) {
						item.classList.remove('is-opened');
						item.setAttribute('aria-expanded', 'false');
						subMenu?.setAttribute('aria-expanded', 'false');

						// Similar to mouseleave, only remove global hover class if focus moved outside nav
						if (!topMenu.contains(e.relatedTarget)) {
							document.body.classList.remove('menu-item__hover');
						}
					}
				},
			};

			const id = getUniqueId();
			eventHandlers.set(id, { element: item, handlers });

			item.addEventListener('mouseenter', handlers.mouseenter);
			item.addEventListener('mouseleave', handlers.mouseleave);

			const link = item.querySelector(
				':scope > a, :scope > .menu-item__link > a'
			);
			if (link) {
				link.addEventListener('focus', handlers.focus);
				link.addEventListener('blur', handlers.blur);
			}
		});

		const navHandlers = {
			mouseleave: (e) => {
				if (!topMenu.contains(e.relatedTarget)) {
					document.body.classList.remove('menu-item__hover');

					menuItems.forEach((navItem) => {
						navItem.classList.remove('is-opened');
						navItem.setAttribute('aria-expanded', 'false');
						navItem
							.querySelector('.sub-menu')
							?.setAttribute('aria-expanded', 'false');
					});
				}
			},
			focusout: (e) => {
				if (!topMenu.contains(e.relatedTarget)) {
					document.body.classList.remove('menu-item__hover');
					closeTopLevel();
				}
			},
		};

		const navId = getUniqueId();
		eventHandlers.set(navId, { element: topMenu, handlers: navHandlers });

		topMenu.addEventListener('mouseleave', navHandlers.mouseleave);
		topMenu.addEventListener('focusout', navHandlers.focusout);

		return menuItems;
	}

	function cleanup() {
		// Detach all previously stored listeners (generic across events)
		eventHandlers.forEach(({ element, handlers }) => {
			if (!element || !handlers) return;

			Object.entries(handlers).forEach(([evt, fn]) => {
				element.removeEventListener(evt, fn);
			});
		});

		eventHandlers.clear();
	}

	const isMobile = () => window.innerWidth <= 992;

	function initHeader() {
		cleanup();

		if (!isMobile()) {
			hoverHeader();
		}
	}

	initHeader();

	let resizeTimeout;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(initHeader, 250);
	});
};
